const summary_cards = [
  { label: 'Commitments tracked', value: '6', note: 'SLAs & milestones', accent: 'dark' },
  { label: 'On track', value: '2', note: 'Meeting target', accent: 'green' },
  { label: 'Due / pending', value: '3', note: 'Action needed', accent: 'amber' },
  { label: 'Breached', value: '1', note: 'Penalty / escalate', accent: 'red' }
];

const filters = [
  { id: 'all', label: 'All', count: 6, active: true },
  { id: 'slas', label: 'SLAs', count: 2 },
  { id: 'grants', label: 'Grants & milestones', count: 4 }
];

const rows_by_tab = {
  all: [
    { ref: 'SD-01', commitment: 'Youth training delivery - 500 learners', party: 'Skillsforce (provider)', target: '500 learners', status: { label: 'On track', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'SD-02', commitment: 'IT support SLA - 4-hour response', party: 'Atlas Cloud Infrastructure', target: '95% within SLA', status: { label: 'Breached', class: 'bg-danger-subtle text-danger-emphasis' } },
    { ref: 'SD-03', commitment: 'Grant Q2 financial & impact report', party: 'NPO implementing partner', target: 'Due 30 Jun 2026', status: { label: 'Due', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'SD-04', commitment: 'Facilities maintenance SLA', party: 'GreenBuild Projects', target: '90% on time', status: { label: 'On track', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'SD-05', commitment: 'Beneficiary verification', party: 'Programme team', target: '1 200 beneficiaries', status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'SD-06', commitment: 'Milestone payment - tranche 2', party: 'NPO implementing partner', target: 'Evidence-gated', status: { label: 'Pending evidence', class: 'bg-warning-subtle text-warning-emphasis' } }
  ],
  slas: [
    { ref: 'SD-01', commitment: 'Youth training delivery - 500 learners', party: 'Skillsforce (provider)', target: '500 learners', status: { label: 'On track', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'SD-02', commitment: 'IT support SLA - 4-hour response', party: 'Atlas Cloud Infrastructure', target: '95% within SLA', status: { label: 'Breached', class: 'bg-danger-subtle text-danger-emphasis' } }
  ],
  grants: [
    { ref: 'SD-03', commitment: 'Grant Q2 financial & impact report', party: 'NPO implementing partner', target: 'Due 30 Jun 2026', status: { label: 'Due', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'SD-04', commitment: 'Facilities maintenance SLA', party: 'GreenBuild Projects', target: '90% on time', status: { label: 'On track', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'SD-05', commitment: 'Beneficiary verification', party: 'Programme team', target: '1 200 beneficiaries', status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'SD-06', commitment: 'Milestone payment - tranche 2', party: 'NPO implementing partner', target: 'Evidence-gated', status: { label: 'Pending evidence', class: 'bg-warning-subtle text-warning-emphasis' } }
  ]
};

export default {
  name: 'ComplyonServiceDeliveryPerformance',
  data: () => ({
    summary_cards,
    filters,
    active_tab: 'all',
    rows_by_tab
  }),
  computed: {
    rows() {
      return this.rows_by_tab[this.active_tab] || this.rows_by_tab.all;
    }
  },
  methods: {
    set_tab(tab_id) {
      this.active_tab = tab_id;
    }
  }
};
